import React from "react";
// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";
import Button from "../components/CustomButtons/Button.js";
import JobsSidebar from "./JobsSidebar";
import styles from "../styles/jss/nextjs-material-kit/pages/landingPageSections/AdviceDetailsStyle.js";
import { secondaryColor } from "../styles/jss/nextjs-material-kit";
import { SanitizeHTML } from "../util/string";
import Grid from "@mui/material/Grid";
import {
  useFavouritesAddRequest,
  useStudentFavouritesListRequest,
} from "../request/api";
import { ROLE_SCHOOL_USER_ID } from "../util/roles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useAuthContext } from "../contexts/auth";
import ArticleLoginBarrier from "../components/ArticleLoginBarrier/ArticleLoginBarrier";

const useStyles = makeStyles()(styles);

export default function ArticleDetails({ article }) {
  const { classes, cx } = useStyles();
  const imageClasses = cx(classes.imgFluid);
  const { auth } = useAuthContext();

  const {
    isMutating: isUpdatingFavourites,
    trigger: addToFavourites,
    error: favouritesError,
  } = useFavouritesAddRequest(
    { type: "article", entityId: article?.id },
    undefined,
    { withCredentials: true }
  );

  const {
    data: favouritesData,
    error: favouritesErrors,
    isLoading: isLoadingFavourites,
    mutate: updateFavourites,
  } = useStudentFavouritesListRequest(
    {
      type: "article",
    },
    {
      shouldFetch: !!auth.user,
    },
    { withCredentials: true }
  );

  const isFavourite = favouritesData
    ?.map((favourite) => favourite.entityId)
    .includes(article?.id);
  const handleFavouriteToggle = async (event) => {
    await addToFavourites();

    await updateFavourites();
  };

  const showLoginBarrier = article.restricted_access && !auth.user;
  return (
    <Grid container justifyContent="space-between">
      <Grid
        item
        style={{
          padding: "0 !important",
          position: 'relative',
          ...(showLoginBarrier ? { minHeight: "220px", maxHeight: "700px", overflowY: "hidden" } : { })
      }}
        className={classes.floatLeft}
        xs={12}
        sm={12}
        md={8}
      >
        <h1 className={classes.cardTitle}>{article.title}
          {auth.user?.role === ROLE_SCHOOL_USER_ID && (
            <>
              {isFavourite ? (
                <>
                  <FavoriteIcon
                    height="16px"
                    onClick={handleFavouriteToggle}
                    className={cx(classes.icons, classes.favouriteIcon, classes.jobIcons)}
                  />
                </>
              ) : (
                <>
                  <FavoriteBorderIcon
                    height="16px"
                    onClick={handleFavouriteToggle}
                    className={cx(classes.icons, classes.favouriteIcon, classes.jobIcons)}
                  />
                </>
              )}
            </>
          )}
        </h1>

        <SanitizeHTML html={article?.content} className="user-content" />

        <Grid item xs={12} sm={12} md={12} className={classes.noLeftPadding}>
          <Button
            style={{ background: secondaryColor }}
            className={cx(classes.lighGreen, classes.btn)}
            color="info"
            onClick={() => {
              if (!navigator.clipboard) {
                alert(
                  "Sharing temporary copy method only works in secure contexts"
                );
                return;
              }

              navigator.clipboard.writeText(window.location.href);
              alert("Copied URL to clipboard!");
            }}
          >
            Share
          </Button>
          {auth.user?.role === ROLE_SCHOOL_USER_ID && (
            <>
              <Button
                className={cx(classes.lighGreen, classes.btn)}
                color="info"
                onClick={handleFavouriteToggle}
              >
                {isFavourite ? (
                  <>
                    <FavoriteIcon
                      height="16px"
                      className={cx(classes.icons, classes.jobIcons)}
                    />
                    Favourited
                  </>
                ) : (
                  <>
                    <FavoriteBorderIcon
                      height="16px"
                      className={cx(classes.icons, classes.jobIcons)}
                    />
                    Favourite
                  </>
                )}
              </Button>
            </>
          )}
        </Grid>

        {showLoginBarrier && (
          <ArticleLoginBarrier />
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={3}>
        <JobsSidebar careerZones={article.career_zones} />
      </Grid>
    </Grid>
  );
}
